export const websiteUrl = 'https://holloid.com'
export const companyName = 'Holloid'
export const appName = 'Portal'
export const privacyPageUrl = `${websiteUrl}/privacy-policy`
export const contactPageUrl = `${websiteUrl}/contact`
